import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHardwareWenchScrew = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "hardware-wench-screw" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,19.371,3.7,16.419A6,6,0,0,0,12.313,13.5H7.5A2.25,2.25,0,0,1,7.5,9h4.813A6,6,0,1,0,1.581,14.3l-.831.831"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.25.75a1.5,1.5,0,0,0,0,3h4.5a1.5,1.5,0,0,0,0-3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21,9.75H18A.75.75,0,0,1,17.25,9V3.75h4.5V9A.75.75,0,0,1,21,9.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.75,
			y1: 6.75,
			x2: 23.25,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.506,13.459A1.5,1.5,0,0,0,17.078,16.1l3.958,2.141A1.5,1.5,0,0,0,22.464,15.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.521,23.16l-2.638-1.428a.75.75,0,0,1-.3-1.017l2.5-4.617,3.958,2.141-2.5,4.618A.751.751,0,0,1,17.521,23.16Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.331,
			y1: 18.022,
			x2: 20.928,
			y2: 21.592
		})
	]
});
export default SvgHardwareWenchScrew;
